import React, { FC } from 'react';
import styles from './menu.module.css';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';

const isCurrSite = (currDomain: string) => {
  return window.location.origin === currDomain;
};

/** 連結指向不同 origin 時才開新分頁（當前站同分頁） */
const isExternalLink = (href: string) => {
  if (!href || href.startsWith('/')) return false;
  try {
    return (
      new URL(href, window.location.origin).origin !== window.location.origin
    );
  } catch {
    return false;
  }
};

const mainDomain = isCurrSite('https://www.ohyagroup.com')
  ? ''
  : process.env.REACT_APP_GROUP_URL || 'https://www.ohyagroup.com';

const energyDomain = isCurrSite('https://www.ohyaenergy.com')
  ? ''
  : process.env.REACT_APP_ENERGY_URL || 'https://www.ohyaenergy.com';

const financeDomain = isCurrSite('https://www.ohyafinance.com')
  ? ''
  : process.env.REACT_APP_FINANCE_URL || 'https://www.ohyafinance.com';

const estateDomain = isCurrSite('https://www.ohyaconst.com')
  ? ''
  : process.env.REACT_APP_CONSTRUCT_URL || 'https://www.ohyaconst.com';

let foodDomain = isCurrSite('https://www.ohyaagtk.com')
  ? ''
  : process.env.REACT_APP_FOOD_URL || 'https://www.ohyaagtk.com';

const EZHOTEL_BOOKING_URL = 'https://rwd.ezhotel.cloud/ohyamotel/3';

export const Menu: FC = () => {
  const location = useLocation();
  const closeMenu = () => {
    const ele = document.getElementById('menuToggle') as HTMLInputElement;
    if (ele) ele.checked = false;
  };
  return (
    <div className="relative">
      <div className={clsx(styles.wrapper)}>
        <div className={clsx(styles.MENU)}>
          <img
            className={clsx(styles['group'])}
            alt=""
            src="/assets/images/group.png"
          />
          <div className={clsx(styles.frame)}>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href={mainDomain + '/'}
                {...(isExternalLink(mainDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <img
                  alt="歐悅集團標誌"
                  src="/assets/images/icon_group_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/intro' &&
                    styles['onActive']
                )}
                href={mainDomain + '/intro'}
                {...(isExternalLink(mainDomain + '/intro') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={clsx(styles['text-wrapper-3'])}>企業理念</div>
              </a>
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/dev' &&
                    styles['onActive']
                )}
                href={mainDomain + '/dev'}
                {...(isExternalLink(mainDomain + '/dev') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>集團發展</div>
              </a>
            </div>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href="https://www.ohyamotel.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                <img
                  alt="歐悅旅館標誌"
                  src="/assets/images/icon_motel_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/hotel/stay' &&
                    location.search === '' &&
                    styles['onActive']
                )}
                href={EZHOTEL_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                <div className={clsx(styles['text-wrapper-3'])}>預訂住宿</div>
              </a>
              {/* <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/hotel/rest' &&
                    location.search === '' &&
                    styles['onActive']
                )}
                onClick={() => navTo(mainDomain + '/hotel/rest')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>預訂休息</div>
              </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/hotel/stay" &&
                  location.search === "?tempB=true" &&
                  styles["onActive"]
              )}
              onClick={() => navTo( mainDomain + "/hotel/stay?tempB=true")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>預訂住宿-B</div>
            </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/hotel/rest" &&
                  location.search === "?tempB=true" &&
                  styles["onActive"]
              )}
              onClick={() => navTo( mainDomain + "/hotel/rest?tempB=true")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>預訂休息-B</div>
            </div> */}
            </div>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href={foodDomain + '/'}
                {...(isExternalLink(foodDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <img
                  alt="歐悅農牧標誌"
                  src="/assets/images/icon_agritek_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FOOD_URL || 'https://www.ohyaagtk.com'
                  )
                    ? true
                    : window.location.origin === foodDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                href={foodDomain + '/market'}
                {...(isExternalLink(foodDomain + '/market') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>行情查詢</div>
              </a>
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                豬隻 &amp; 飼料試算
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/info" && styles["onActive"]
              )}
              onClick={() => navTo( foodDomain + "/info")}
            >
              <div className={styles["text-wrapper-3"]}>行情資訊</div>
            </div> */}
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                行情資訊
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
            </div>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href={financeDomain + '/'}
                {...(isExternalLink(financeDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <img
                  alt="歐悅金融科技標誌"
                  src="/assets/images/icon_finance_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                href={financeDomain + '/loan?lead-source=network'}
                {...(isExternalLink(
                  financeDomain + '/loan?lead-source=network'
                ) && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={clsx(styles['text-wrapper-3'])}>貸款申請</div>
              </a>
              {/* <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/aboutus' &&
                    styles['onActive']
                )}
                onClick={() => navTo(financeDomain + '/aboutus')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>關於我們</div>
              </div>

              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/intro' &&
                    styles['onActive']
                )}
                onClick={() => navTo(financeDomain + '/intro')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>歐悅貸介紹</div>
              </div> */}

              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/my-loan" && styles["onActive"]
              )}
              onClick={() => navTo( financeDomain + "/my-loan")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>繳費與查詢</div>
            </div> */}

              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
                <div
                  className={clsx(
                    styles["text-wrapper-3"],
                    "!text-[color:var(--neutralneutral-400)]"
                  )}
                >
                  繳費與查詢
                </div>
                <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
              </div> */}
            </div>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href={energyDomain + '/'}
                {...(isExternalLink(energyDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <img
                  alt="歐悅能源標誌"
                  src="/assets/images/icon_energy_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/esg' &&
                    styles['onActive']
                )}
                href={energyDomain + '/esg'}
                {...(isExternalLink(energyDomain + '/esg') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>企業社會責任</div>
              </a>
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/service/rental' &&
                    styles['onActive']
                )}
                href={energyDomain + '/service/rental'}
                {...(isExternalLink(energyDomain + '/service/rental') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>服務項目</div>
              </a>
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/project' &&
                    styles['onActive']
                )}
                href={energyDomain + '/project'}
                {...(isExternalLink(energyDomain + '/project') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>實績案例</div>
              </a>
            </div>
            <div className={styles.div}>
              <a
                className={styles['text-wrapper']}
                href={estateDomain + '/'}
                {...(isExternalLink(estateDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <img
                  alt="歐悅建設標誌"
                  src="/assets/images/icon_const_menu.svg"
                />
              </a>
              <div className={styles.rectangle} />
              <a
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_CONSTRUCT_URL ||
                      'https://www.ohyaconst.com'
                  )
                    ? true
                    : window.location.origin === estateDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                href={estateDomain + '/'}
                {...(isExternalLink(estateDomain + '/') && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                onClick={closeMenu}
              >
                <div className={styles['text-wrapper-3']}>歐悅建設介紹</div>
              </a>
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                歐悅建設介紹
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
              {/* <div
                className={clsx(
                  styles["frame-3"],
                  window.location.origin === energyDomain && 
                  location.pathname === "/practice" && styles["onActive"]
                )}
                onClick={() => navTo( energyDomain + "/practice")}
              >
                <div className={styles["text-wrapper-3"]}>最新消息</div>
              </div> */}
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                最新消息
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
            </div>
          </div>
          {/* <div className="max-w-[1440px] w-full mx-auto">

        </div> */}
        </div>
      </div>
      <div
        className="w-screen h-screen absolute"
        onClick={() => {
          const ele = document.getElementById('menuToggle') as HTMLInputElement;
          ele.checked = !ele.checked;
        }}
      ></div>
    </div>
  );
};
